module.exports = __webpack_public_path__ + "static/media/cooley.9dff08ed.png";